module.exports = __webpack_public_path__ + "static/media/logo-filadelfia.f1ec95aa.png";